import React, { useState, useEffect } from "react";
import commonUtils from "../../../helpers/commonUtils";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import FeedBackAction from "../../../Actions/FeedBackAction";
import AppConstants from "../../../Constants/AppConstants";
export default function AddFeedBack(props) {
  const { eqID, feedBackDetails, closeAddEditfeedBackPopUpCallback } = props;
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [feedBack, setFeedBack] = useState("");
  const [feedBackId, setFeedBackId] = useState(null);

  useEffect(() => {
    setFeedBack(feedBackDetails ? feedBackDetails.bezeichnung : "");
    setFeedBackId(feedBackDetails.id ? feedBackDetails.id : null);
  }, [props]);

  const feedBackAdd = (e) => {
    e.preventDefault();
    const feedBackData = {
      ID: feedBackId !== null ? feedBackId : AppConstants.DEFAULT_GUID,
      Bezeichnung: feedBack.trim(),
      eqID: eqID,
    };
    setGlobalSpinner(true);
    feedBackId !== null
      ? commonUtils.setIsEdit(true)
      : commonUtils.setIsEdit(false);
    FeedBackAction.saveUpdateFeedBack(feedBackData);
  };

  function handleClosePopOver() {
    if (!feedBackDetails) {
      setFeedBack("");
      setFeedBackId(null);
    }
    closeAddEditfeedBackPopUpCallback();
  }

  return (
    <div
      className="modal fade"
      id="addFeedback"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addFeedback"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addFeedbackHead">
              {feedBackDetails !== ""
                ? localization.editFeedBack
                : localization.addFeedBack}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addFeedbackModalClose"
              onClick={handleClosePopOver}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form
            id="createPruefGroupForm"
            name="createPruefGroupFormm"
            onSubmit={feedBackAdd}
          >
            <div className="modal-body">
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="feedBack"
                      name="feedBack"
                      placeholder={localization.enterFeedBack}
                      required
                      value={feedBack}
                      onChange={(e) => {
                        e.preventDefault();
                        if (feedBack !== "") {
                          setFeedBack(e.target.value);
                        } else {
                          setFeedBack(e.target.value.trim());
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                  disabled={feedBack !== "" ? false : true}
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
